const multipleSelectStyles = {
  control: (styles, { isFocused }) => ({
    ...styles,
    borderColor: isFocused ? '#0278E4' : '#E6E8E9',
    borderRadius: '4px',
    '&:hover': {
      borderColor: isFocused ? '#0278E4' : '#D3D6D8',
    },
  }),
  placeholder: (styles) => ({
    ...styles,
    color: '#E6E8E9',
  }),
  multiValue: (styles) => ({
    ...styles,
    backgroundColor: '#36383A',
    borderRadius: '4px',
  }),
  multiValueLabel: (styles) => ({
    ...styles,
    color: '#fff',
    paddingLeft: '0.75rem',
  }),
  multiValueRemove: (styles) => ({
    ...styles,
    color: '#fff',
    '&:hover': {
      color: '#fff',
      backgroundColor: '#74787D',
    },
  }),
};

export default multipleSelectStyles;
